import React from "react";

import pkg from "../../lib/pkg";
import { AnalyticsError } from "../../lib/util";
import { IntegrationCategory } from "../../providers/AnalyticsContext";
import useTrackEvent from "../useTrackEvent";
import { mapActivityListingToProduct } from "./util";

import type { ProductAdded } from "@outschool/data-schemas";

import type { ActivityListing, User } from "./types";

const EVENT_NAME = "Product Added";

export default function useProductAdded() {
  const trackAdEvent = useTrackEvent(IntegrationCategory.Advertising);
  const [tracked, setTracked] = React.useState<boolean>(false);

  function track({
    activityListing,
    user,
    pricingOffer,
    enrollModalType,
    enrollmentDuration,
  }: {
    activityListing: ActivityListing;
    user: Pick<User, "slug_id">;
    pricingOffer?: string;
    enrollModalType: ProductAdded["enroll_modal_type"];
    enrollmentDuration?: string;
  }) {
    try {
      if (!activityListing || tracked) {
        return;
      }

      const product: Omit<
        ProductAdded,
        "cart_id" | "coupon" | "enroll_modal_type"
      > = mapActivityListingToProduct(activityListing);

      const properties: ProductAdded = {
        ...product,
        enrollmentDuration,
        cart_id: `${activityListing.activity.slug_id}-${user.slug_id}`,
        // legacy prop
        pricingOffer,
        enroll_modal_type: enrollModalType,
      };

      trackAdEvent(EVENT_NAME, properties);
    } catch (error) {
      pkg.onError(new AnalyticsError(EVENT_NAME, error));
    }

    setTracked(true);
  }

  return React.useCallback(track, [trackAdEvent, tracked]);
}
